import React from "react";
import { Radio } from "tea-component";
import OptionItemInfo from "./OptionItemInfo";
import { IRadioGroupProps, TOptionsItem } from "../types";
import { sanitizeRichHtml } from '@sg/utils/sanitizeHtml';

const RadioGroup = (props: IRadioGroupProps) => {
  const { value, options, formatMessage, onChange } = props || {};

  return (<div className="db-filter-select-radio-context">
    {options?.length > 0 && (<>
      <div className="db-filter-select-radio-title">
        <span className="db-filter-select-radio-label">{formatMessage({ id: 'radioGroupTitle' })}</span>
      </div>
      <div className="db-filter-select-radio-context-list">
        <Radio.Group
          value={value}
          onChange={onChange}
        >
          {
            options?.map((item: TOptionsItem) => item?.render ? item?.render(item) : <Radio key={item?.value} name={item?.value} disabled={item?.disable}>
              <span dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(`${item?.text}`) }} />
              <OptionItemInfo infoItem={item} />
            </Radio>)
          }
        </Radio.Group>
      </div>
    </>)}
  </div>);
};

export default RadioGroup;